import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var stateKey = new PluginKey('tasksAndDecisionsPlugin');